import React, { Component } from 'react';
import Swal from 'sweetalert2';
import { connect } from 'react-redux';

import {
	getSectionGuardians,
	toggleSelectedSection,
	checkSitePermission
} from 'actions/sections';

import { Expandable, Spinner } from 'UI';
import { Checkbox, Icon, translate } from '@haldor/ui';

import './MultipleSectionSelector.scss';
import DisplayName from 'components/Presentation/DisplayName';

import { getMyOwnedEducationGroups, getGroupById } from 'actions/groups';

class MultipleSectionSelector extends Component {

	constructor(props) {
		super(props);

		this.state = {
			groups: [],
			loading: true,
		};
	}

	componentWillUnmount = () => {
		this.setState({ groups: [] });
	}

	componentDidUpdate = (prevProps) => {
		if (prevProps.selectGuardians != this.props.selectGuardians) {
			this.onUpdateResult();
		}
	}

	componentDidMount = async () => {
		this.setState({ loading: true });
		var myEducationGroups = await this.props.getMyOwnedEducationGroups();

		// Filter out groups where the user is an owner
		var ownedEducationGroups = myEducationGroups.filter(t => t.userRole != null && t.userRole.toLowerCase() == 'owner');
		this.setState({ groups: JSON.parse(JSON.stringify(ownedEducationGroups)), loading: false });

		if (this.state.groups != null) {
			this.state.groups.forEach(group => {
				if (this.props.value != null) {
					if (group.id == this.props.value) {
						group.checked = false;
						this.onGroupChange(group);
					}
				}
			});
		}
	}
	promptMissingPermission = () => {
		const { translate } = this.props;

		Swal.fire({
			title: translate('missing-site-permission'),
			showCancelButton: false,
			confirmButtonText: translate('Ok'),
			html: `
            ${translate('You cannot create libraries, folders, or files. As a result, workspaces and assignments cannot be created for the group. Contact your school administrator for assistance.')}
            `,
		});
	}
	promptEmpty = () => {
		const { translate } = this.props;
		if (this.props.type == 'assignment') {
			Swal.fire({
				title: this.props.translate('The group contains no students'),
				showCancelButton: false,
				confirmButtonText: this.props.translate('Ok'),
				html: `
				${translate('The group you selected does not contain any students. You can`t create assignments for a group without students. The group may lack students due to the fact that:')}
				<br />
				<ul>
					<li>${translate('No students have been added to the group. Make sure your team/Microsoft 365 group includes students.')}</li>
					<li>${translate('Students have not been activated on the team. To do this, use Microsoft Teams.')}</li>
					<li>${translate('The group could not be loaded correctly. Close the form and reload the page, then try again.')}</li>
				</ul>
				<br />
				`,
			});
		}

		if (this.props.type == 'plan') {
			Swal.fire({
				title: this.props.translate('The group contains no students'),
				showCancelButton: false,
				confirmButtonText: this.props.translate('Ok'),
				html: `
				${translate('create-planning-selected-group-no-students')}
				<br />
				<ul>
					<li>${translate('No students have been added to the group. Make sure your team/Microsoft 365 group includes students.')}</li>
					<li>${translate('Students have not been activated on the team. To do this, use Microsoft Teams.')}</li>
					<li>${translate('The group could not be loaded correctly. Close the form and reload the page, then try again.')}</li>
				</ul>
				<br />
				`,
			});
		}
	}
	onGroupChange = async (group, checked) => {
		if (this.props.consentLevel == 2 && (checked === true || (group.checked === false && checked === undefined))) {
			try {
				group.checkingPermission = true;
				this.setState({});
				const hasPermission = await this.props.checkSitePermission(group.id);

				group.checkingPermission = false;

				if (hasPermission === false) {
					group.missingPermission = true;

					this.promptMissingPermission();

					if (this.props.type === 'assignment') {
						group.checked = false;
						this.setState({});
						return;
					}
				} else {
					group.missingPermission = false;
				}
			} catch (error) {
				group.checkingPermission = false;
			}
		}

		if (!group.checked) {
			group.checked = true;
		} else {
			group.checked = checked;
		}
		if (group.members == null || group.members.length == 0) {
			this.loadSectionStudents(group, group.checked);
		}

		if (group.members != null) {
			if (group.checked && group.members.length == 0) {
				if (this.props.type == 'assignment') {
					group.checked = false;
					this.setState({});
					return false;
				}
			}
			this.markSectionStudents(group, checked);
		}

		this.setState({});
		this.props.toggleSelectedSection(group);
	}


	onGroupOpenChange = async (group) => {
		group.open = !group.open;
		this.setState({});

		if (group.members == null || group.members.length == 0) {
			await this.loadSectionStudents(group);
		}
	}

	markSectionStudents = (section, checked) => {
		if (this.props.selectGuardians) {
			section.members.forEach((student) => {
				student.guardians.forEach(guardian => {
					guardian.checked = checked;
					student.checked = section.checked;
				});
			});
		} else {
			section.members.forEach((student) => {
				student.checked = checked;
			});
		}

		section.allStudentsSelected = true;
		this.setState({}, () => {
			this.onUpdateResult();
		});
	}


	loadSectionStudents = async (group, prompt = false) => {
		let groups = this.state.groups;

		let stateSection = groups.find(t => t.id == group.id);
		stateSection.loading = true;

		this.setState({ groups });;

		if (this.props.selectGuardians) {
			this.props.getSectionGuardians(group.id)
				.then(() => {
					stateSection.members = JSON.parse(JSON.stringify(this.props.guardians));

					stateSection.members.forEach((student) => {
						student.guardians.forEach(guardian => {
							guardian.checked = group.checked;
						});

						student.checked = group.checked;
					});

					stateSection.loading = false;
					this.setState({ groups }, () => {
						this.onUpdateResult();
					});
				});
		} else {
			var groupFromStore = await this.props.getGroupById(group.id, ['members', 'courses']);
			stateSection.members = JSON.parse(JSON.stringify(groupFromStore.members));
			stateSection.courses = JSON.parse(JSON.stringify(groupFromStore.courses));

			if (stateSection.members != null) {
				if (stateSection.members.length == 0 && prompt) {
					this.promptEmpty();

					if (this.props.type == 'assignment') {
						stateSection.checked = false;
					}
				}

				stateSection.members.forEach((student) => {
					student.checked = group.checked;
				});
			}
			stateSection.loading = false;
			this.setState({ groups }, () => {
				this.onUpdateResult();
			});
		}

	}

	onGuardiansUpdate = (section) => {
		const checkedGuardians = section.members.find((student) => {
			return student.guardians.find(guardian => {
				return guardian.checked == true;
			});
		});

		if (checkedGuardians != null) {
			section.checked = true;
		} else {
			section.checked = false;
		}

		this.setState({}, () => {
			this.onUpdateResult();
		});
	}

	onStudentsUpdate = (section) => {
		const checkedStudents = section.members.filter(function (student) {
			return student.checked == true;
		});

		if (checkedStudents != null && checkedStudents.length > 0) {
			if (!section.checked) {
				this.props.toggleSelectedSection(section);
			}

			if (checkedStudents != null && checkedStudents.length == section.members.length) {
				section.allStudentsSelected = true;
			} else {
				section.allStudentsSelected = false;
			}

			section.checked = true;
		} else {
			// No students are no longer checked
			if (section.checked) {
				this.props.toggleSelectedSection(section);
				section.allStudentsSelected = null;
			}

			section.checked = false;
		}

		this.setState({}, () => {
			this.onUpdateResult();
		});
	}

	onStudentChange = (student, section) => {
		student.checked = student.checked ? false : true;

		this.setState({}, () => {
			this.onStudentsUpdate(section);
		});
	}

	onGuardianChange = (guardian, section) => {
		guardian.checked = guardian.checked ? false : true;

		this.setState({}, () => {
			this.onGuardiansUpdate(section);
		});
	}

	onUpdateResult = () => {
		let filtered = this.state.groups.filter(t => t.checked);
		let groups = [];

		filtered.forEach((section) => {
			let sectionObject = {
				id: section.id,
				courses: section.courses,
				type: section.type,
				students: section.members != null ? section.members.filter(t => t.checked) : [],
				allStudentsSelected: section.members != null && section.members.length > 0 ? section.members.every(student => student.checked) : false,
				graphId: section.graphId,
				title: section.title,
			}

			if (this.props.selectGuardians) {
				sectionObject.guardians = [];
				section.members.forEach(student => {
					if (student.guardians != null) {
						student.guardians.forEach(guardian => {
							if (guardian.checked) {
								sectionObject.guardians.push(guardian);
							}
						});
					}
				});
			}

			groups.push(sectionObject);
		});
		this.props.onChange(groups);
	}

	onSectionOpen = (group, toggle) => {
		if (group.open != null) {
			group.open = !group.open;
		} else {
			group.open = true;
		}

		if (group.members == null || group.members.length == 0) {
			this.loadSectionStudents(group);
		}

		toggle();
	}

	renderStudent = (student, section) => {
		const displayName =
			<DisplayName
				firstName={student.firstName}
				lastName={student.lastName}
				email={student.email}
				data={section.members}
			/>
		if (this.props.selectGuardians) {
			return <div style={{ marginTop: '0.75rem' }} key={student.id}>
				{student.firstName} {student.lastName}
				<div style={{ marginTop: '0.45rem' }}>
					{student.guardians.map(guardian => {
						return <Checkbox
							key={student.id + '-' + guardian.id}
							onChange={() => this.onGuardianChange(guardian, section)}
							value={guardian.checked}
							label={`${guardian.firstName} ${guardian.lastName != null ? guardian.lastName : ''}`}
						/>
					})}
				</div>
			</div>
		}

		return <div key={student.id}>
			<Checkbox
				onChange={() => this.onStudentChange(student, section)}
				value={student.checked}
				label={displayName}
			/>
		</div>
	}

	renderSection = (section) => {
		const title = (
			<div className="df aic jcb">
				<div style={{ flex: 1 }}>
					<Checkbox
						value={section.checked && (section.allStudentsSelected == null || section.allStudentsSelected)}
						indeterminate={section.checked != null && section.checked && section.allStudentsSelected != null && !section.allStudentsSelected}
						onChange={(checked) => this.onGroupChange(section, checked)}
						label={section.title}
						disabled={this.props.disabled || section.classroomUrl == null || section.classroomUrl == ''}
					/>
				</div>

				{section.missingPermission ?
					<span style={{ fontWeight: 400, fontSize: '1rem', marginRight: '1rem' }}>
						<span style={{ position: 'relative', top: 2, marginRight: '.3rem' }}>
							<Icon name="Alert_Red" />
						</span>
						{this.props.translate('missing-site-permission') || 'Missing permission'}
					</span>
					: null}

				{section.members != null && section.members.length == 0 ?
					<span style={{ fontWeight: 400, fontSize: '1rem', marginRight: '1rem' }}>
						<span style={{ position: 'relative', top: 2, marginRight: '.3rem' }}>
							<Icon name="Alert_Red" />
						</span>
						{this.props.translate('The group contains no students')}
					</span>
					: null}

				{section.classroomUrl == null || section.classroomUrl == '' ?
					<span style={{ fontWeight: 400, fontSize: '1rem', marginRight: '1rem' }}>
						<span style={{ position: 'relative', top: 2, marginRight: '.3rem' }}>
							<Icon name="Alert_Red" />
						</span>
						{this.props.translate('Workspace missing')}
					</span>
					: null}
			</div>
		);

		if (section.open == null) {
			section.open = false;
		}

		return (
			<Expandable
				open={section.open}
				title={title}
				key={section.id}
				onPlus={toggle => { this.onGroupOpenChange(section) }}
				onClick={toggle => { return false; }}
			>
				{section.error ?
					<div className="section-error">
						{section.error}
					</div>
					: null}

				{section.loading ?
					<Spinner small center />
					: null}

				{section.members ?
					section.members
						.sort((a, b) => (a.lastName || "").localeCompare(b.lastName || ""))
						.map(student => this.renderStudent(student, section))
					: null}
			</Expandable>
		);
	}

	render() {
		const { disabled } = this.props;
		let { groups } = this.state;

		if (this.state.loading) {
			return <Spinner center />;
		}

		if (groups != null) {
			return (
				<div className={disabled ? "multi-user-select disabled" : "multi-user-select"}>
					{groups.map(section => {
						return this.renderSection(section)
					})}
				</div>
			);
		}

		return (
			<div className="user-select">
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		translate: translate(state.Languages.translations),
		guardians: state.sections.guardians,
		consentLevel: state.user.tenant.consentLevel,
	};
}

export default connect(mapStateToProps, {
	getSectionGuardians,
	toggleSelectedSection,
	getMyOwnedEducationGroups,
	getGroupById,
	checkSitePermission
})(MultipleSectionSelector);